/*
  Cabeçalho da datatable de compra por multiplas filiais
 */

export default [
  { text: "", value: "data-table-select", width: '5px' },
  { text: "Expandir", value: "data-table-expand", width: '5px' },
  { text: "Descrição Produto", value: "descricao_produto" },
  {
    text: "UM",
    value: "unidade_compra",
    sortable: false,
  },
  {
    text: "Embalagem",
    value: "embalagem_master_desc",
    class: 'border-right-table-multifiliais',
    sortable: false,
    cellClass: 'border-right-table-multifiliais'
  },
  { text: "Filial", value: "filial", sortable: false, align: 'center' },
  { text: "Data", value: "data_entrada", sortable: false, align: 'center' },
  { text: "Total da Embalagem", value: "total_ult_entrada", sortable: false, align: 'center' },
  {
    text: "Qtde.",
    value: "qtde_entrada",
    sortable: false,
    align: 'center',
    class: 'border-right-table-multifiliais',
    cellClass: 'border-right-table-multifiliais'
  },
  {
    text: "Atacado",
    value: "preco_atacado_varejo",
    sortable: false,
    align: 'center',
    class: 'border-right-table-multifiliais',
    cellClass: 'border-right-table-multifiliais'
  },
  /*
  {
    text: "Atacado",
    value: "preco_atacado",
    sortable: false,
    align: 'center'
  },
  {
    text: "Varejo",
    value: "preco_varejo",
    sortable: false,
    align: 'center',
    class: 'border-right-table-multifiliais',
    cellClass: 'border-right-table-multifiliais'
  },
   */
  {
    text: "Proj. Venda",
    value: "consumo_medio_mensal",
    sortable: false,
    align: 'center'
  },
  {
    text: "mes_ant_0",
    value: "qtde_venda_ant0",
    sortable: false, align: 'center'
  },
  {
    text: "mes_ant_1",
    value: "qtde_venda_ant1",
    sortable: false,
    align: 'center'
  },
  {
    text: "mes_ant_2",
    value: "qtde_venda_ant2",
    sortable: false,
    align: 'center',
    class: 'border-right-table-multifiliais',
    cellClass: 'border-right-table-multifiliais'
  },
  { text: "Disponível", value: "estoque", sortable: false, align: 'center' },
  {
    text: "Trânsito",
    value: "estoque_transito",
    class: 'border-right-table-multifiliais',
    sortable: false,
    align: 'center',
    cellClass: 'border-right-table-multifiliais'
  },
  {
    text: "Saída",
    value: "saida_icms",
    class: 'border-right-table-multifiliais',
    sortable: false,
    align: 'center',
    cellClass: 'border-right-table-multifiliais'
  },
  { text: "ICMS", value: "icms", sortable: false, align: 'center' },
  { text: "%IVA", value: "iva", sortable: false, align: 'center' },
  { text: "Inter", value: "inter", sortable: false, align: 'center' },
  { text: "Ext", value: "ext", sortable: false, align: 'center' },
  { text: "Pis", value: "pis", sortable: false, align: 'center' },
  {
    text: "Cofins",
    value: "cofins",
    class: 'border-right-table-multifiliais',
    sortable: false,
    align: 'center',
    cellClass: 'border-right-table-multifiliais'
  },
  { text: "Último Preço", value: "preco_custo", sortable: false, align: 'center' },
  {
    text: "Sugestão",
    value: "sugestao",
    sortable: false,
    align: 'left',
    class: 'border-right-table-multifiliais',
    cellClass: 'border-right-table-multifiliais'
  },
  { text: "Ações", value: "action", sortable: false },
]
